/** Human-readable redemption request / settlement labels. */

export function redemptionStatusLabel(status) {
  const s = String(status || "").toUpperCase();
  if (s === "PENDING") return "Pending";
  if (s === "COMPLETED") return "Fulfilled";
  if (s === "PARTIALLY_COMPLETED") return "Partially fulfilled";
  if (s === "REJECTED") return "Rejected";
  if (s === "CANCELLED") return "Cancelled";
  if (s === "APPROVED") return "Approved";
  return s || "—";
}

export function redemptionStatusTone(status) {
  const s = String(status || "").toUpperCase();
  if (s === "PENDING") return "badge-PENDING";
  if (s === "COMPLETED") return "badge-APPROVED";
  if (s === "PARTIALLY_COMPLETED") return "badge-PENDING";
  if (s === "REJECTED" || s === "CANCELLED") return "badge-REJECTED";
  return "badge";
}

export function settlementStatusLabel(status) {
  const s = String(status || "").toUpperCase();
  if (s === "PENDING") return "Settlement pending";
  if (s === "SETTLED") return "Settled";
  if (s === "FAILED") return "Settlement failed";
  if (s === "NOT_REQUIRED") return "—";
  return s || "—";
}
